import styled from 'styled-components';
import { colorTextDisabled } from '@atlas-frontend/design-tokens';

export const TextDisabled = styled.span`
  color: ${colorTextDisabled};
  cursor: not-allowed;
`;
